var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { createElement } from 'react';
import { useProps, useStore } from '../../utils/mobx.utils';
import { YYYYMMDD } from '../../utils/time.utils';
import BaseCalendarDay from './BaseCalendarDay';
import BaseCalendarTimelineAxis from './BaseCalendarTimelineAxis';
import './BaseCalendarWeek.scss';
function BaseCalendarWeek(props) {
    var style = props.style, rest = __rest(props, ["style"]);
    var p = useProps(__assign({}, rest));
    var s = useStore(function () { return ({
        get startDate() {
            return p.startDate || p.state.startDate;
        },
        get startOfDaysMoments() {
            return Array(7).fill(null).map(function (n, i) { return moment(s.startDate).add(i, 'days'); });
        },
        get startOfDays() {
            return s.startOfDaysMoments.map(function (m) { return m.format(YYYYMMDD); });
        },
        get daysRendered() {
            return s.startOfDays.map(function (d, i) { return React.createElement(BaseCalendarDay, __assign({ key: d, day: d, index: i }, p)); });
        },
        get children() {
            return React.createElement(React.Fragment, null,
                p.state.shouldDisplayAsTimeline && React.createElement(BaseCalendarTimelineAxis, null),
                s.daysRendered);
        }
    }); });
    return React.createElement(Observer, { children: function () { return (createElement(p.state.shouldDisplayAsTimeline ? 'div' : 'tr', {
            className: 'BaseCalendarWeek',
            style: style,
        }, p.state.shouldDisplayAsTimeline ? (React.createElement("div", { className: "BaseCalendarWeekInner" }, s.children)) : s.children)); } });
}
export default BaseCalendarWeek;
